import { DictionariesTranslation } from '@/assets/locales/dictionaries/dictionaries.translations.pl.ts';
import { notificationsDictionariesTranslation } from '@/assets/locales/dictionaries/notifications/notifications.dictionaries.en.ts';
import { rolesDictionariesTranslation } from '@/assets/locales/dictionaries/roles/roles.dictionaries.en.ts';
import { toStateOptionsDictionariesTranslation } from '@/assets/locales/dictionaries/toStateOptions/toStateOptions.dictionaries.en.ts';
import { yesNoDictionariesTranslation } from '@/assets/locales/dictionaries/yesNo/yesNo.dictionaries.translation.en.ts';

export const dictionariesTranslation: DictionariesTranslation = {
  notifications: notificationsDictionariesTranslation,
  roles: rolesDictionariesTranslation,
  toStateOptions: toStateOptionsDictionariesTranslation,
  yesNo: yesNoDictionariesTranslation,
};
